export default __webpack_public_path__ + "static/media/Snowcloud Cloak.d9a197a0.jpg";